<template>
  <header class="actionbar">
    <div ref="innerEl" class="actionbar__inner">
      <router-link :to="{ name: 'home' }" class="actionbar__logo">PAXA</router-link>
      <nav class="actionbar__nav" aria-label="主导航">
        <router-link
          v-for="item in items"
          :key="item.key"
          :to="{ name: item.routeName }"
          class="actionbar__link"
          active-class="actionbar__link--active"
        >
          {{ item.label }}
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script>
/** 顶部导航项：routeName 与 src/router/index.js 中 name 一致 */
const NAV_ITEMS = [
  { key: 'home', label: '首页', routeName: 'home' },
  { key: 'product', label: '产品中心', routeName: 'product' },
  { key: 'brand', label: '品牌故事', routeName: 'brand' },
  { key: 'contact', label: '联系我们', routeName: 'contact' }
]

export default {
  name: 'ActionBar',
  data() {
    return {
      items: NAV_ITEMS,
      /** 用于卸载时断开 ResizeObserver */
      innerResizeObserver: null
    }
  },
  watch: {
    /** 换页后顶栏高度可能变化，重写 CSS 变量避免 hero 计算偏差 */
    $route() {
      this.$nextTick(() => {
        this.syncInnerHeight()
      })
    }
  },
  mounted() {
    this.syncInnerHeight()
    this.$nextTick(() => {
      const el = this.$refs.innerEl
      if (!el || typeof ResizeObserver === 'undefined') {
        if (!el) {
          console.error('[ActionBar] innerEl ref 未就绪，无法同步顶栏高度')
        }
        return
      }
      this.innerResizeObserver = new ResizeObserver(() => {
        this.syncInnerHeight()
      })
      this.innerResizeObserver.observe(el)
    })
  },
  beforeUnmount() {
    if (this.innerResizeObserver) {
      this.innerResizeObserver.disconnect()
      this.innerResizeObserver = null
    }
  },
  methods: {
    /** 把 actionbar__inner 高度写到 :root，供 hero 区 calc(100svh - x) 使用 */
    syncInnerHeight() {
      const el = this.$refs.innerEl
      if (!el) {
        return
      }
      const h = Math.round(el.getBoundingClientRect().height)
      document.documentElement.style.setProperty('--actionbar-inner-height', `${h}px`)
      console.info('[ActionBar] --actionbar-inner-height =', h)
    }
  }
}
</script>

<style scoped>
.actionbar {
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.actionbar__inner {
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 48px;
  box-sizing: border-box;
}

.actionbar__logo {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.12em;
  color: #000;
  text-decoration: none;
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
}

.actionbar__nav {
  display: flex;
  align-items: center;
  gap: 40px;
}

.actionbar__link {
  position: relative;
  padding: 4px 0;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 15px;
  color: #000;
  font-family: 'PingFang SC', 'Microsoft YaHei', system-ui, sans-serif;
  font-weight: 400;
  text-decoration: none;
}

.actionbar__link:hover {
  opacity: 0.65;
}

.actionbar__link--active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -2px;
  height: 1px;
  background: #000;
}
</style>
